// frontend/src/pages/portfolio/sections/FinalCtaSection.tsx
import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Download } from "lucide-react";
import { getMicrosoftStoreUrl } from "../../../utils/storeUrl";
import { container, sectionReveal } from "../components/styles";

const FinalCtaSection: React.FC = () => {
  return (
    <section
      id="final-cta"
      className="relative border-t border-primary-200/30 bg-primary-900 py-20 text-white sm:py-24"
      aria-labelledby="final-cta-heading"
    >
      <div
        className="pointer-events-none absolute inset-0 -z-0"
        aria-hidden
      >
        <div className="absolute left-1/2 top-1/2 h-96 w-[40rem] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-400/15 blur-3xl motion-reduce:hidden" />
      </div>

      <div className={`relative ${container} text-center ${sectionReveal}`}>
        <h2
          id="final-cta-heading"
          className="font-display text-3xl font-semibold tracking-tight text-white sm:text-4xl lg:text-5xl"
          style={{ lineHeight: 1.1 }}
        >
          Start tracking time today.
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg text-primary-100/95 sm:text-xl">
          Free for your whole team. AI is optional.
        </p>
        <div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row sm:gap-4">
          <Link
            to="/register-org"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl bg-white px-6 py-3 text-base font-semibold text-primary-950 shadow-elevated hover:bg-slate-100 transition-colors min-h-[48px] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary-900"
          >
            Start free
            <ArrowRight className="h-5 w-5" aria-hidden />
          </Link>
          <a
            href={getMicrosoftStoreUrl()}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex w-full sm:w-auto items-center justify-center gap-2 rounded-xl border-2 border-white/35 bg-white/10 px-6 py-3 text-base font-semibold text-white backdrop-blur-sm hover:border-white/55 hover:bg-white/15 transition-colors min-h-[48px] focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-primary-900"
          >
            <Download className="h-5 w-5" aria-hidden />
            Get the app
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCtaSection;
